import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/media/illustrations/statistics.png'


const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "card-header border-0 pt-5" }, [
  /*#__PURE__*/_createVNode("h3", { class: "card-title align-items-start flex-column" }, [
    /*#__PURE__*/_createVNode("span", { class: "card-label fw-bolder text-dark" }, "Create New Gateway")
  ])
], -1)
const _hoisted_3 = { class: "row g-5 g-xl-8" }
const _hoisted_4 = { class: "col-xl-5" }
const _hoisted_5 = { class: "card-body p-0" }
const _hoisted_6 = { class: "card-px" }
const _hoisted_7 = /*#__PURE__*/_createVNode("label", { class: "col-sm-5 col-form-label fw-bold fs-6" }, "Driver Name", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("label", { class: "col-sm-5 col-form-label fw-bold fs-6" }, "Gateway Key", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("label", { class: "col-sm-5 col-form-label fw-bold fs-6" }, "Gateway Name", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("label", { class: "col-sm-5 col-form-label fw-bold fs-6" }, "Email", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("label", { class: "col-sm-5 col-form-label fw-bold fs-6" }, "Phone", -1)
const _hoisted_12 = { class: "text-end py-6 px-5" }
const _hoisted_13 = { class: "indicator-label" }
const _hoisted_14 = /*#__PURE__*/_createVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "col-xl-5" }, [
  /*#__PURE__*/_createVNode("div", { class: "text-center mb-10" }, [
    /*#__PURE__*/_createVNode("p", { class: "text-gray-400 fs-5 fw-bold mb-2" }, [
      /*#__PURE__*/_createVNode("span", null, "Please fill the form to create a new gateway")
    ])
  ]),
  /*#__PURE__*/_createVNode("div", { class: "d-flex justify-content-center" }, [
    /*#__PURE__*/_createVNode("img", {
      src: _imports_0,
      alt: "",
      class: "mw-100 mh-300px"
    })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_form = _resolveComponent("el-form")

  return (_openBlock(), _createBlock("section", null, [
    _createVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode(_component_el_form, {
                id: "create_gateway_form",
                model: _ctx.create,
                ref: "formRef",
                class: "form"
              }, {
                default: _withCtx(() => [
                  _hoisted_7,
                  _createVNode(_component_el_form_item, { prop: "driver" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        size: "small",
                        placeholder: "Please input driver name",
                        modelValue: _ctx.create.driver,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.create.driver = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _hoisted_8,
                  _createVNode(_component_el_form_item, { prop: "name" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        size: "small",
                        placeholder: "Please input gateway key",
                        modelValue: _ctx.create.key,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.create.key = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _hoisted_9,
                  _createVNode(_component_el_form_item, { prop: "name" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        size: "small",
                        placeholder: "Please input gateway name",
                        modelValue: _ctx.create.name,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.create.name = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _hoisted_10,
                  _createVNode(_component_el_form_item, { prop: "email" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        size: "small",
                        placeholder: "Please input email",
                        modelValue: _ctx.create.email,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.create.email = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _hoisted_11,
                  _createVNode(_component_el_form_item, { prop: "phone" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        size: "small",
                        placeholder: "Please input account account number",
                        modelValue: _ctx.create.phone,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.create.phone = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ])
          ]),
          _createVNode("div", _hoisted_12, [
            _createVNode("button", {
              type: "reset",
              class: "btn btn-white btn-active-light-primary me-2",
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.resetForm && _ctx.resetForm(...args)))
            }, " Reset "),
            _createVNode("button", {
              type: "button",
              ref: "submitButton",
              class: "btn btn-primary",
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)))
            }, [
              _createVNode("span", _hoisted_13, _toDisplayString(_ctx.translate("submit")), 1),
              _hoisted_14
            ], 512)
          ])
        ]),
        _hoisted_15
      ])
    ])
  ]))
}